import axios from 'axios'

// railExpanded / railWide ถูกถอดออกแล้ว (rail กางด้วย hover เก็บ state ใน Home.vue ไม่ persist)
// ค่าเก่าที่ค้างใน localStorage['vuex'] จะถูก merge กลับมาแต่ไม่มีใครอ่าน จึงไม่มีผล
const state = {
  type: 'inbox',
  menuCount: null,
  navItem: 'conversation-customer'
}

const actions = {
  fetchMenuCount: async ({ commit }, payload = {}) => {
    // รีเซ็ต menu count ใน store ยกเว้นกรณีที่ caller ปิดการ commit เข้า store ไว้
    const shouldCommitToStore = payload.commitToStore !== false
    if (shouldCommitToStore) {
      commit('SET_MENU_COUNT', null)
    }

    const url = '/menu-count'
    const config = {}
    if (payload.params) {
      config.params = payload.params
    }

    const res = await axios.get(url, config)
    if (res.status === 200) {
      const menuCount = res.data
      if (shouldCommitToStore) {
        commit('SET_MENU_COUNT', menuCount)
      }
      return menuCount
    }

    return null
  }
}

const mutations = {
  SET_MENU_COUNT: (state, menuCount) => {
    state.menuCount = { ...menuCount }
  },
  SET_TYPE_MENU: (state, type) => {
    state.type = null
    state.type = type
  },
  SET_NAV_ITEM: (state, value) => {
    state.navItem = value
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
